import React, { useState } from "react";
import {
    Modal,
    Box,
    Typography,
    TextField,
    Select,
    MenuItem,
    InputLabel,
    FormControl,
    Checkbox,
    FormControlLabel,
    Button,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { getUserDetails } from "../../Redux/Users/action";

export default function GiveAccessModal({ modalOpen, setModalOpen, selectedUser }) {
    const dispatch = useDispatch();

    const [accessType, setAccessType] = useState("full-access");
    const [validityMonths, setValidityMonths] = useState(12);
    const [manualAmount, setManualAmount] = useState(0);
    const [freeAccess, setFreeAccess] = useState(false);
    const [giveAccessProgress, setGiveAccessProgress] = useState(false);

    const giveAccessFun = async () => {
        setGiveAccessProgress(true);

        const res = await fetch(
            `https://api.sovrenn.com/manual/${accessType}/${selectedUser?._id}?amount=${manualAmount}&free_access=${freeAccess}&validity_in_months=${validityMonths}`,
            {
                method: "PATCH",
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("sov_user"),
                },
            }
        ).then((r) => r.json());

        setGiveAccessProgress(false);

        if (res.success) {
            setManualAmount(0);
            setFreeAccess(false);
            setValidityMonths(12);
            setAccessType("full-access");
            dispatch(getUserDetails(selectedUser?._id));
            setModalOpen(false);
            alert("Access has been given successfully");
            return;
        }

        alert("Something went wrong");
    };

    return (
        <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    p: 4,
                    bgcolor: "background.paper",
                    maxWidth: 400,
                    borderRadius: 2,
                    boxShadow: 24,
                }}
            >
                <Typography variant="h5" gutterBottom>
                    {selectedUser?.first_name} {selectedUser?.last_name}
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                    Email: {selectedUser?.email}
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    Phone: {selectedUser?.phone_number}
                </Typography>

                <FormControl fullWidth sx={{ mb: 2 }}>
                    <InputLabel>Access Type</InputLabel>
                    <Select
                        value={accessType}
                        onChange={(e) => setAccessType(e.target.value)}
                        label="Access Type"
                    >
                        <MenuItem value="full-access">Full Access</MenuItem>
                        <MenuItem value="trial">Trial Access</MenuItem>
                        <MenuItem value="news">News Access</MenuItem>
                        <MenuItem value="life">Life Access</MenuItem>
                    </Select>
                </FormControl>

                <FormControl fullWidth sx={{ mb: 2 }}>
                    <InputLabel>Validity</InputLabel>
                    <Select
                        value={validityMonths}
                        onChange={(e) => setValidityMonths(Number(e.target.value))}
                        label="Validity"
                    >
                        <MenuItem value={6}>6 Months</MenuItem>
                        <MenuItem value={12}>1 Year</MenuItem>
                        <MenuItem value={24}>2 Years</MenuItem>
                        <MenuItem value={36}>3 Years</MenuItem>
                        <MenuItem value={60}>5 Years</MenuItem>
                        <MenuItem value={120}>10 Years</MenuItem>
                    </Select>
                </FormControl>

                <TextField
                    fullWidth
                    type="number"
                    label="Amount"
                    value={manualAmount}
                    onChange={(e) => setManualAmount(e.target.value)}
                    sx={{ mb: 2 }}
                />

                <FormControlLabel
                    control={
                        <Checkbox
                            checked={freeAccess}
                            onChange={(e) => setFreeAccess(e.target.checked)}
                        />
                    }
                    label="Is Free Access"
                />

                <Button
                    fullWidth
                    variant="contained"
                    onClick={giveAccessFun}
                    disabled={giveAccessProgress}
                    sx={{ mt: 2 }}
                    color="info"
                >
                    {giveAccessProgress ? "Processing..." : "Give Access"}
                </Button>
            </Box>
        </Modal>
    );
}